import { Injectable } from '@angular/core';
import { CentralDatabaseProvider } from '../central-database.provider';
import { Observable } from 'rxjs';
import { RxCollection, RxDatabase } from 'rxdb';
import { CentralDatabaseDbContext } from '../schemas/central-database.dbcontext';
import { CentralDatabaseKeys } from '../schemas/central-database-keys';
import { map } from 'rxjs/operators';
import { ProjectModel } from '@shared';
import { WorkspaceModel } from '../models';

@Injectable()
export class ProjectRepository {
	private centralDb: RxDatabase<CentralDatabaseDbContext>;
	private workspaceCollection: RxCollection<WorkspaceModel>;

	public constructor(centralDbProvider: CentralDatabaseProvider) {
		this.centralDb = centralDbProvider.getDatabase();
		this.workspaceCollection = this.centralDb[CentralDatabaseKeys.workspaces];
	}

	public getByWorkFileId$(workfileId: string): Observable<ProjectModel[]> {
		return this.workspaceCollection
			.findOne()
			.where(CentralDatabaseKeys.workFileId)
			.eq(workfileId)
			.$.pipe(map((workfileList) => workfileList[CentralDatabaseKeys.projects]));
	}
}
